module.exports = __webpack_public_path__ + "img/christmas-hero-2023-desktop.b1912701.jpg";